import Footer from "../../components/footer";
import Header from "../../components/header";
import "./UploadResearch.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { Trash2 } from "lucide-react";
import { useMediaQuery } from "react-responsive";
import MobileHeader from "../../components/MobileHeader";

const UPLOAD_OPTIONS = [
  {
    value: "both",
    title: "Add both a public and private file",
    description:
      "Upload a public file which everyone can access, and save a private copy of the same file as a backup which only you and the co-authors can access.",
  },
  {
    value: "public",
    title: "Add only a public file",
    description: "Upload a public file which everyone can access and read.",
  },
  {
    value: "private",
    title: "Add only a private file",
    description:
      "Save a private file as a backup which only you and the co-authors can access.",
  },
];

export default function UploadResearch() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [step, setStep] = useState(1);
  const [uploadType, setUploadType] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "journal";

  const handleSkip = () => {
    localStorage.removeItem("uploadedResearchFile");
    navigate(`/publish/${type}`);
  };
  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSelectedFile(file);
    setStep(2);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setUploadType("");
    setIsChecked(false);
    setStep(1);
  };

  const handleUpload = () => {
    if (!selectedFile) return;

    navigate(`/publish/${type}`, {
      state: { uploadedFile: selectedFile },
    });
  };

  const fileSizeKB = selectedFile
    ? Math.round(selectedFile.size / 1024).toLocaleString()
    : 0;

  return (
    <div>
      {isMobile ? (
        <MobileHeader hideSearchBar={true} />
      ) : (
        <Header hideSearchBar={true} />
      )}
      <div
        className="main add_module"
        style={{ minHeight: "100vh", display: "flex", alignItems: "centre" }}
      >
        <div className="upload-container" style={{ margin: "auto" }}>
          <div className="upload-heading-block">
            <h2>Add research to your profile</h2>
          </div>
          {step === 1 && (
            <div className="upload-box">
              <h3>Do you want to add a file?</h3>

              <label className="upload-label">
                <input type="file" hidden onChange={handleFileUpload} />
                <span>Select and upload file</span>
              </label>

              <div className="upload-footer">
                <p>You can add details about this research in the next step</p>
                <button className="skip-btn" onClick={handleSkip}>
                  Skip
                </button>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="upload-box">
              <div className="file-info">
                <p>
                  <strong>{selectedFile?.name}</strong> ({fileSizeKB} KB)
                </p>
                <button className="remove-btn" onClick={handleRemoveFile}>
                  <Trash2 size={16} />
                  Remove
                </button>
              </div>

              <h3>Select how you want to upload your file</h3>

              <div className="upload-options">
                {UPLOAD_OPTIONS.map((opt) => (
                  <label key={opt.value} className="option-card">
                    <input
                      type="radio"
                      name="uploadType"
                      value={opt.value}
                      checked={uploadType === opt.value}
                      onChange={(e) => setUploadType(e.target.value)}
                    />
                    <div className="option-content">
                      <div className="option-title">{opt.title}</div>
                      <div className="option-desc">{opt.description}</div>
                    </div>
                  </label>
                ))}
              </div>

              <div className="verify-check">
                <label>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                  />{" "}
                  I have reviewed and verified each file I am uploading. I have
                  the right to share each file publicly and/or store a private
                  copy accessible to me and the co-authors, as applicable. By
                  uploading this file, I agree to the Upload Conditions.
                </label>
              </div>

              <div className="upload-actions">
                <button className="skip-btn" onClick={handleSkip}>
                  Skip
                </button>
                <button
                  className="upload-btn"
                  onClick={handleUpload}
                  disabled={!isChecked || !uploadType}
                >
                  Upload
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
